/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { ApplicationStatusPageAgent, getAgent } from './agent';
const is = require('is_js');

const SERVICE_NAME = 'ApplicationStatusPageService';

@injectable()
export class ApplicationStatusPageService {
  public agent: ApplicationStatusPageAgent;
  static displayName = 'ApplicationStatusPageService';

  constructor(props: any = {}) {
    this.agent = getAgent();
  }
}
